// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetailsModal_infoItem__VT51h {
    margin-bottom: 12px;
    padding: 8px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.UserDetailsModal_infoItem__VT51h:hover {
    background-color: #f8f9fa;
}

.UserDetailsModal_label__aOneC {
    color: #878a99;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.UserDetailsModal_value__Kvk22 {
    color: #495057;
    font-size: 13px;
    font-weight: 500;
}

/* ... other styles ... */

/* Add these styles */
.user-carousel {
    height: 100%;
}

.user-carousel .carousel-inner {
    height: 100%;
    border-radius: 12px;
}

.user-carousel .carousel-item {
    height: 100%;
    background-color: #f8f9fa;
}

.user-carousel .carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 10px;
}

.user-carousel .carousel-control-prev,
.user-carousel .carousel-control-next {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    /*background-color: rgba(0, 0, 0, 0.5);*/
    top: 50%;
    transform: translateY(-50%);
    margin: 0 10px;
    opacity: 0.8;
}

.user-carousel .carousel-control-prev:hover,
.user-carousel .carousel-control-next:hover {
    opacity: 1;
    /*background-color: rgba(0, 0, 0, 0.7);*/
}

.user-carousel .carousel-indicators {
    margin-bottom: 0;
    position: absolute;
    bottom: 20px;
    gap: 5px;
}

.user-carousel .carousel-indicators button {
    width: 25px;
    height: 3px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0;
    opacity: 0.5;
    border: none;
}

.user-carousel .carousel-indicators button.active {
    background-color: #fff;
    opacity: 1;
    width: 25px;
}

/* Add these styles for section headers */
.section-icon {
    color: #405189;
    font-size: 16px;
    background: none;
    padding: 0;
}

/* Add styles for the modal */
.user-details-modal .modal-content {
    border: none;
    border-radius: 12px;
    background-color: #fff;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.user-details-modal .modal-header {
    background-color: #fff;
    border-bottom: none;
    border-radius: 12px 12px 0 0;
    padding: 16px 24px;
}

.user-details-modal .modal-body {
    padding: 20px;
    background-color: #fff;
    border-radius: 0 0 12px 12px;
}

.user-details-modal .modal-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #495057;
    font-size: 15px;
    font-weight: 600;
}

.user-details-modal .modal-title i {
    color: #405189;
    font-size: 16px;
}

.user-details-modal .btn-close {
    font-size: 14px;
    padding: 0;
    margin: 0;
    opacity: 1;
    /*background: none;*/
    border: none;
}

.user-details-modal .btn-close:hover {
    opacity: 0.75;
    transform: none;
}

/* Add new styles for better visual hierarchy */
.info-value-highlight {
    color: #405189;
    font-weight: 600;
}

.info-section-wrapper {
    background-color: #fff;
    transition: all 0.3s ease;
}

.info-section-wrapper:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 10px rgba(0,0,0,0.08);
} `, "",{"version":3,"sources":["webpack://./src/Components/Common/UserDetailsModal.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;;AAEzB,qBAAqB;AACrB;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,+CAA+C;AAC/C;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C","sourcesContent":[".infoItem {\n    margin-bottom: 12px;\n    padding: 8px;\n    border-radius: 6px;\n    transition: all 0.3s ease;\n}\n\n.infoItem:hover {\n    background-color: #f8f9fa;\n}\n\n.label {\n    color: #878a99;\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.value {\n    color: #495057;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* ... other styles ... */\n\n/* Add these styles */\n:global(.user-carousel) {\n    height: 100%;\n}\n\n:global(.user-carousel .carousel-inner) {\n    height: 100%;\n    border-radius: 12px;\n}\n\n:global(.user-carousel .carousel-item) {\n    height: 100%;\n    background-color: #f8f9fa;\n}\n\n:global(.user-carousel .carousel-item img) {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    padding: 10px;\n}\n\n:global(.user-carousel .carousel-control-prev),\n:global(.user-carousel .carousel-control-next) {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    /*background-color: rgba(0, 0, 0, 0.5);*/\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0 10px;\n    opacity: 0.8;\n}\n\n:global(.user-carousel .carousel-control-prev:hover),\n:global(.user-carousel .carousel-control-next:hover) {\n    opacity: 1;\n    /*background-color: rgba(0, 0, 0, 0.7);*/\n}\n\n:global(.user-carousel .carousel-indicators) {\n    margin-bottom: 0;\n    position: absolute;\n    bottom: 20px;\n    gap: 5px;\n}\n\n:global(.user-carousel .carousel-indicators button) {\n    width: 25px;\n    height: 3px;\n    border-radius: 2px;\n    background-color: rgba(255, 255, 255, 0.5);\n    margin: 0;\n    opacity: 0.5;\n    border: none;\n}\n\n:global(.user-carousel .carousel-indicators button.active) {\n    background-color: #fff;\n    opacity: 1;\n    width: 25px;\n}\n\n/* Add these styles for section headers */\n:global(.section-icon) {\n    color: #405189;\n    font-size: 16px;\n    background: none;\n    padding: 0;\n}\n\n/* Add styles for the modal */\n:global(.user-details-modal .modal-content) {\n    border: none;\n    border-radius: 12px;\n    background-color: #fff;\n    box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n:global(.user-details-modal .modal-header) {\n    background-color: #fff;\n    border-bottom: none;\n    border-radius: 12px 12px 0 0;\n    padding: 16px 24px;\n}\n\n:global(.user-details-modal .modal-body) {\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 0 0 12px 12px;\n}\n\n:global(.user-details-modal .modal-title) {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #495057;\n    font-size: 15px;\n    font-weight: 600;\n}\n\n:global(.user-details-modal .modal-title i) {\n    color: #405189;\n    font-size: 16px;\n}\n\n:global(.user-details-modal .btn-close) {\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n    opacity: 1;\n    /*background: none;*/\n    border: none;\n}\n\n:global(.user-details-modal .btn-close:hover) {\n    opacity: 0.75;\n    transform: none;\n}\n\n/* Add new styles for better visual hierarchy */\n:global(.info-value-highlight) {\n    color: #405189;\n    font-weight: 600;\n}\n\n:global(.info-section-wrapper) {\n    background-color: #fff;\n    transition: all 0.3s ease;\n}\n\n:global(.info-section-wrapper:hover) {\n    transform: translateY(-2px);\n    box-shadow: 0 3px 10px rgba(0,0,0,0.08);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoItem": `UserDetailsModal_infoItem__VT51h`,
	"label": `UserDetailsModal_label__aOneC`,
	"value": `UserDetailsModal_value__Kvk22`
};
export default ___CSS_LOADER_EXPORT___;
